<template>
  <div style="margin: 15px 0">
    <div class="total-count">
      <p class="content">Total Results: {{ paginationDetails.totalCount }}</p>
    </div>
    <div class="pagination" role="navigation" aria-label="pagination">
     
      
      <ul class="pagination-list">
        <li>
         <a
        class="pagination-previous"
        @click="$emit('update', 1)"
        :disabled="paginationDetails.totalPages === 1"
        >First page</a
      >
      </li>
        <li v-for="(page, index) in pageNumbersToDisplay(paginationDetails.totalPages)" :key="index">
          <a
            class="pagination-link"
            :class="{ 'is-current': page === paginationDetails.currentPage }"
            @click="$emit('update', page)"
            >{{ page }}</a
          >
        </li>
        <li>
        <a
        class="pagination-next"
        @click="$emit('update', paginationDetails.totalPages)"
        :disabled="paginationDetails.totalPages === 1"
        >Last page</a
      >
      </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: ['paginationDetails'],
  data() {
    return {}
  },
  methods: {
    pageNumbersToDisplay(number) {
      this.pagesToShow = []

      for(this.i = 1; this.i <= number; this.i++){
        if(this.paginationDetails.currentPage > 5){
        if(this.i <= this.paginationDetails.currentPage + 5 && this.i >= this.paginationDetails.currentPage - 5 ){
        this.pagesToShow.push(this.i)
        }
      } else {
        if(this.i <= this.paginationDetails.currentPage + (10 - this.paginationDetails.currentPage) && this.i >= this.paginationDetails.currentPage - 9 ){
        this.pagesToShow.push(this.i)
        }
      }
      }

    return this.pagesToShow
    },
  },
}
</script>

<style scoped>
.element {
  margin: 10px 0;
}
.box {
  margin: 10px 0;
}

.total-count {
  text-align: right;
  margin-bottom: 10px;
}
</style>
